import { render, staticRenderFns } from "./modifyPage.vue?vue&type=template&id=c4bf1f0c&scoped=true&"
import script from "./modifyPage.vue?vue&type=script&lang=js&"
export * from "./modifyPage.vue?vue&type=script&lang=js&"
import style0 from "./modifyPage.vue?vue&type=style&index=0&id=c4bf1f0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bf1f0c",
  null
  
)

export default component.exports